import React, {Component} from 'react';
class Contact extends Component {
    render() {
	    return (
		<div>
			<div className="breadcrumbs overlay" style={{backgroundImage: 'url("../img/driver.jpeg")' ,backgroundSize: "cover" , backgroundPosition: "center" , position: "relative" , padding: "150px 0px 75px"}}>
				<div className="container">
					<div className="bread-inner">
						<div className="row">
							<div className="col-12">
								<h2>Contact Us</h2>
								<ul className="bread-list">
									<li><a href="index.html">Home</a></li>
									<li><i className="icofont-simple-right"></i></li>
									<li className="active">Contact Us</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<section className="contact-us section section_p30">
				<div className="container">
					<div className="inner">
						<div className="row"> 
							<div className="col-lg-6">
								<div className="contact-us-left">
                                 <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1557198.568891008!2d-83.9905546378523!3d40.333395180963386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8836e97ab54d8ec1%3A0xe5cd64399c9fd916!2sOhio%2C%20USA!5e0!3m2!1sen!2sin!4v1698236543066!5m2!1sen!2sin" width="100%" height="100%" style={{border:0}} loading="lazy"></iframe>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="contact-us-form">
									<h2>Contact Us</h2>
									<p>Do you have a rush delivery, medical courier request, or questions about same day delivery? Please do not hesitate to get in contact with our team below. We will get back to you ASAP!</p>
									<form className="form" method="post" action="mail/mail.php">
										<div className="row">
											<div className="col-lg-6">
												<div className="form-group">
													<input type="text" name="name" placeholder="Name" required="" />
												</div>
											</div>
											<div className="col-lg-6">
												<div className="form-group">
													<input type="email" name="email" placeholder="Email" required="" />
												</div>
											</div>
											<div className="col-lg-6">
												<div className="form-group">
													<input type="text" name="phone" placeholder="Phone" required="" />
												</div>
											</div>
											<div className="col-lg-6">
												<div className="form-group">
													<input type="text" name="subject" placeholder="Subject" required="" />
												</div>
											</div>
											<div className="col-lg-12">
												<div className="form-group">
													<textarea name="message" placeholder="Your Message" required=""></textarea>
												</div>
											</div>
											<div className="col-12">
												<div className="form-group login-btn">
													<button className="btn" type="submit">Send</button>
												</div>
												<div className="checkbox">
													<label className="checkbox-inline" htmlFor="2"><input name="news" id="2" type="checkbox" />Do you want to subscribe our Newsletter ?</label>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					<div className="contact-info">
						<div className="row">
							<div className="col-lg-4 col-12 ">
								<div className="single-info">
									<i className="icofont icofont-ui-call"></i>
									<div className="content">
										<h3>330-624-8815</h3>
										<p>info@redixpress.com</p>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-12 ">
								<div className="single-info">
									<i className="icofont-google-map"></i>
									<div className="content">
										<h3>1502 Brittain Rd #1058 Akron, OH 44310</h3>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-12 ">
								<div className="single-info">
									<i className="icofont icofont-wall-clock"></i>
									<div className="content">
										<h3>We operate 24/7</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		);
    }
}
export default Contact;